export const ValueType = {
    PERCENT: 'percent',
    COUNT: 'count',
    AVERAGE: 'average'
}